export type CssClassMap = { [className: string]: boolean }

export interface IUploadFile {
  name: string
  size?: number
}
